module.exports = __webpack_public_path__ + "img/install-profile-animation-2a31553ff8d77164482414d2bbb249bb.gif";